import React from 'react';
import PropTypes from 'prop-types';
import styles from './instoreCollection.module.scss';
import { Button } from '../../ds';

const ActionBarSection = ({
  onCreateOrder,
  onShowStaticQr,
  hasStoreSelected,
  hasStaticQr,
}) => {
  const shouldShowQrButton = hasStoreSelected && hasStaticQr;

  return (
    <div className={styles.actionBar}>
      <div className={styles.actionBarButtons}>
        <Button type='primary' onClick={onCreateOrder}>
          Crear orden
        </Button>
        {shouldShowQrButton && (
          <Button type='secondary-alternate' onClick={onShowStaticQr}>
            QR de tienda
          </Button>
        )}
      </div>
    </div>
  );
};

ActionBarSection.propTypes = {
  onCreateOrder: PropTypes.func.isRequired,
  onShowStaticQr: PropTypes.func,
  hasStoreSelected: PropTypes.bool,
  hasStaticQr: PropTypes.bool,
};

export default ActionBarSection;
